import { FC } from 'react'
import { RoundTripIcon } from '@/root/ui/shared/icons/RoundTripIcon'

interface DividerProps {
  color?: string
  type?: 'solid' | 'dotted'
  vertical?: boolean
}

export const Divider: FC<DividerProps> = ({ color = 'base-medium-light', type = 'solid', vertical = false }) => {
  if (vertical) {
    return (
      <div className="flex flex-col items-center gap-y-3.5">
        <RoundTripIcon width={40} color={color} />
        {type === 'solid' ? (
          <div className={`bg-${color} w-px flex-1`} />
        ) : (
          <div className={`border-${color} w-px flex-1 border-s-3 border-dotted`} />
        )}
      </div>
    )
  }

  return (
    <div className="max-w-content relative mx-auto flex h-max w-full items-center justify-start gap-x-2.5 py-5">
      <RoundTripIcon width={40} color={color} />
      {type === 'solid' ? (
        <div className={`bg-${color} h-px w-full`} />
      ) : (
        <div className={`border-${color} h-px w-full border-t-3 border-dotted`} />
      )}
    </div>
  )
}
